import Box from "@/ui/atoms/Box";
import Typography from "@/ui/atoms/Typography";
import { Button, Modal } from "@proda-ai/ui-kit";

import logoBlue from "../TopBar/Proda_logo_blue.svg";

export type UserAcknowledgementModalProps = {
    showModal: boolean;
    userConsentChecked: boolean;
    onConfirm: () => void;
    setUserConsentChecked: (consent: boolean) => void;
};

export const testIds = {
    modal: "UserAcknowledgementModal-modal",
};

export const UserAcknowledgementModal = ({
    showModal,
    userConsentChecked,
    onConfirm,
    setUserConsentChecked,
}: UserAcknowledgementModalProps) => {
    const header = () => {
        return (
            <Box
                sx={{
                    marginRight: "auto",
                }}
            >
                <Box
                    component={"img"}
                    src={logoBlue}
                    alt="Logo"
                    id="proda-logo"
                />
            </Box>
        );
    };

    const renderBody = () => {
        const links = [
            {
                label: "Terms and Conditions",
                href: "/user-policies/",
                target: "_self",
            },
            {
                label: "Privacy Policy",
                href: "https://proda.ai/privacy-policy/",
            },
            {
                label: "Cookie Policy",
                href: "https://proda.ai/cookie-policy/",
            },
        ];

        return (
            <Box
                sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                data-testid={testIds.modal}
            >
                <Typography variant="body2">
                    Please confirm that you have read and agree to the following
                    terms:
                </Typography>
                <Box
                    component="span"
                    sx={{ display: "flex", gap: 1, alignItems: "center" }}
                >
                    <Box
                        component="input"
                        type="checkbox"
                        checked={userConsentChecked}
                        onChange={e => {
                            setUserConsentChecked(e.target.checked);
                        }}
                    />
                    <Typography variant="body3">
                        I acknowledge that I have read and accept the{" "}
                        {links.map((link, idx) => (
                            <Box
                                component="a"
                                key={link.href}
                                href={link.href}
                                target={link.target ?? "_blank"}
                                sx={{
                                    color: "var(--proda-neon-blue)",
                                }}
                            >
                                {idx === 0 ? link.label : `, ${link.label}`}
                            </Box>
                        ))}
                        . I understand that these documents outline my rights
                        and responsibilities.
                    </Typography>
                </Box>
            </Box>
        );
    };

    const renderModalFooter = () => {
        return (
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                <Button
                    onClick={onConfirm}
                    pattern="primary"
                    size="large"
                    disabled={!userConsentChecked}
                >
                    Confirm
                </Button>
            </Box>
        );
    };

    return (
        <Modal
            hideCloseButton
            open={showModal}
            onClose={() => {}}
            headerTitle={header()}
            onConfirm={onConfirm}
            textCancel="Cancel"
            textConfirm="Confirm"
            footer={renderModalFooter()}
        >
            {renderBody()}
        </Modal>
    );
};
